import { onUnmounted, ref, Ref } from '@vue/composition-api';
import i18n, { i18n_t } from '@/locales/i18n';
import downloadHandler from '@/renderer/components/SpacePage/compositions/downloadHandler';
import smh, { SMH } from '@/renderer/scripts/smh';
import tips, { MsgError } from '@/renderer/scripts/utils/tips';
import { protocolUrlMap } from '@/common/constant';
import router from '@/renderer/router/index';
import store from '@/renderer/store';
import storage from '@/renderer/scripts/utils/storage';
import ipc from '@/renderer/scripts/utils/ipc';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
type TeamPathInfo = {
  path: string[];
  spaceId: string;
};
type Handler = {
  showFail: Ref<boolean>; // 拉起失败
  showLoading: Ref<boolean>; // 展示拉起客户端提示
  methods: {
    getCodeInfo: (code: string) => void;
    saveDownloadInfo: (params: any) => void;
  };
};
export default function handler(): Handler {
  const showLoading = ref(false);
  const showFail = ref(false);
  const { name: routerName } = router.currentRoute;
  const spaceId = ref('');
  let codeKeep = '';
  const { methods: downloadMethods } = downloadHandler(spaceId);
  const methods = {
    async getCodeInfo(code: string) {
      try {
        const { data } = await smh.userAPI.getCodeInfo({
          code,
        });
        const { routerName, downloadData, currPath, spaceInfo } = data;
        if (routerName === 'teamSpace' && spaceInfo) {
          storage.set(storage.StoreKey.TEAM_PATH, spaceInfo);
          spaceId.value = spaceInfo.spaceId;
        } else if (routerName === 'relatedToMeFileList') {
          storage.set(storage.StoreKey.RECV_SHARE_SPACE, spaceInfo);
          spaceId.value = spaceInfo.spaceId;
        } else {
          spaceId.value = '';
        }
        storage.set(storage.StoreKey.REMOTE_PATH, {
          routerName,
          remoteFolder: currPath,
        });
        dispatchRouter({ name: 'transit' }, 'replace').then(() => {
          downloadMethods.prepareDownload(downloadData);
        });
      } catch (error: any) {
        // 未登录的状态也会查询此接口，以告知web端客户端已拉起，此时报错为ParamInvalid，提示无法下载
        if (!store.getters.isLogined) {
          error.code === 'ParamInvalid' && tips.error(i18n_t('未登录，无法下载'));
        } else {
          tips.error(error as MsgError);
        }
      }
    },
    async saveDownloadInfo(params: any) {
      try {
        // 处理存储信息
        let spaceInfo;
        if (routerName === 'teamSpace') {
          spaceInfo = storage.get<TeamPathInfo | null>(storage.StoreKey.TEAM_PATH) as TeamPathInfo;
        }
        if (routerName === 'relatedToMeFileList') {
          spaceInfo = storage.get(storage.StoreKey.RECV_SHARE_SPACE);
        }
        const options = {
          routerName,
          spaceInfo,
        };
        const { data } = await smh.userAPI.saveCodeInfo({
          ...options,
          ...params,
        });
        const { code } = data;
        codeKeep = code;
        methods.pullUpClient();
      } catch (error) {
        tips.error(error as MsgError);
      }
    },
    pullUpClient() {
      if (!codeKeep) return;
      const url = `${protocolUrlMap.download}?code=${codeKeep}&_=${Date.now()}`;
      const a = document.createElement('a');
      a.href = url;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      showLoading.value = true;
      showFail.value = false;
      setTimeout(() => {
        methods.checkCodeVisit(codeKeep, 1);
      }, 1000);
    },
    async checkCodeVisit(code: string, counts: number) {
      if (counts > 10) {
        showLoading.value = false;
        showFail.value = true;
        return;
      }
      try {
        const { data } = await smh.userAPI.checkCodeVisit({
          code,
        });
        if (data.visits) {
          showLoading.value = false;
          return;
        }
        setTimeout(() => {
          // eslint-disable-next-line no-param-reassign
          methods.checkCodeVisit(code, ++counts);
        }, 1000);
      } catch (error) {
        showLoading.value = false;
        showFail.value = true;
        tips.error(error as MsgError);
      }
    },
    reset() {
      showFail.value = false;
    },
  };
  ipc.on(ipc.RENDERER_EVENTS_MAP.RESTART, methods.pullUpClient);
  onUnmounted(() => {
    ipc.off(ipc.RENDERER_EVENTS_MAP.RESTART, methods.pullUpClient);
  });
  return {
    methods,
    showLoading,
    showFail,
  };
}
